"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableTheme = exports.tableSortLabelTheme = exports.tableRowTheme = exports.tablePaginationTheme = exports.tableHeadTheme = exports.tableFooterTheme = exports.tableContainerTheme = exports.tableCellTheme = void 0;

var tableContainerTheme = function tableContainerTheme(theme) {
  return {
    root: {
      border: "1px solid ".concat(theme.palette.divider),
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      '&:last-child': {
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6
      }
    }
  };
};

exports.tableContainerTheme = tableContainerTheme;

var tableTheme = function tableTheme(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.paper
    }
  };
};

exports.tableTheme = tableTheme;

var tableHeadTheme = function tableHeadTheme(theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      '& > tr': {
        '& > th': {
          fontWeight: 700
        }
      }
    }
  };
};

exports.tableHeadTheme = tableHeadTheme;

var tableRowTheme = function tableRowTheme(theme) {
  return {
    root: {
      height: 56,
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.divider)
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary[10],
        '&:hover, &.Mui-focusVisible': {
          backgroundColor: theme.palette.primary[10]
        }
      }
    },
    head: {
      '& > th': {
        lineHeight: '16px'
      }
    }
  };
};

exports.tableRowTheme = tableRowTheme;

var tableCellTheme = function tableCellTheme(theme) {
  return {
    root: {
      height: 56,
      padding: '14px 16px',
      borderBottom: 'none',
      fontSize: 16,
      lineHeight: '20px',
      '& > div, & > span': {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
          marginRight: 6
        }
      },
      '&.hidden': {
        display: 'none'
      }
    },
    body: {
      color: theme.palette.neutral[90]
    }
  };
};

exports.tableCellTheme = tableCellTheme;
var tableSortLabelTheme = {
  root: {
    '&:focus-visible': {
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: -1,
      '& > svg': {
        opacity: 0.5
      }
    },
    '& > svg': {
      width: 20,
      height: 20,
      color: 'inherit !important'
    }
  }
};
exports.tableSortLabelTheme = tableSortLabelTheme;

var tableFooterTheme = function tableFooterTheme(theme) {
  return {
    root: {
      borderTop: "1px solid ".concat(theme.palette.divider),
      padding: 16
    }
  };
};

exports.tableFooterTheme = tableFooterTheme;

var tablePaginationTheme = function tablePaginationTheme(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.paper,
      borderWidth: '0px 1px 1px 1px',
      borderStyle: 'solid',
      borderColor: theme.palette.divider,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      '& > .MuiToolbar-root': {
        padding: 16
      }
    },
    toolbar: {
      '& > p': {
        fontSize: 16
      }
    },
    input: {
      border: "1px solid ".concat(theme.palette.divider)
    },
    selectRoot: {
      height: 36,
      width: 72,
      marginBottom: 0,
      '&.Mui-focused': {
        outline: '5px auto Highlight'
      }
    },
    select: {
      padding: '8px 0px'
    }
  };
};

exports.tablePaginationTheme = tablePaginationTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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